var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"copyright-content"},[_vm._v("亿志愿智能高报平台")]),_c('div',{staticClass:"copyright-content"},[_vm._v("北京祝余科技有限公司 版权所有@2024-2025")]),_c('div',{staticClass:"copyright-content"},[_vm._v("京ICP备2024100908号-1")])])])
}]

export { render, staticRenderFns }